<template>
  <div>
    <h4 class="mb-4"><strong>El número posee un plan activo</strong></h4>
    <p></p>

    <a href="https://mivirgin.virginmobile.cl/" class="btn btn-primary" type="button">
      Ir a Surcursal Virtual
    </a>

  </div>
</template>

<script>
export default {
  name: 'PaymentTariffActive',

  setup() {
    return {
      error: {
        msisdn: false
      },
      msisdn: '',
    }
  },
}
</script>

<style scoped>
</style>
